// https://www.inclusivecolors.com/
export const inclusiveYellow = {
  '50': '#fcf4d6',
  '100': '#fddc69',
  '200': '#f9cf2e',
  '300': '#f1c21b',
  '400': '#d2a106',
  '500': '#b28600',
  '600': '#8e6a00',
  '700': '#684e00',
  '800': '#483700',
  '900': '#302400',
  '950': '#1c1500',
};

export const inclusiveGreen = {
  '50': '#defbe6',
  '100': '#a7f0ba',
  '200': '#89e7a2',
  '300': '#6fdc8c',
  '400': '#42be65',
  '500': '#24a148',
  '600': '#198038',
  '700': '#0e6027',
  '800': '#044317',
  '900': '#022d0d',
  '950': '#071908',
};

export const inclusiveGray = {
  '50': '#f4f4f4',
  '100': '#e0e0e0',
  '200': '#d3d3d3',
  '300': '#c6c6c6',
  '400': '#a8a8a8',
  '500': '#8d8d8d',
  '600': '#6f6f6f',
  '700': '#525252',
  '800': '#393939',
  '900': '#262626',
  '950': '#161616',
};

export const inclusiveOrange = {
  '50': '#fff2e8',
  '100': '#ffd9be',
  '200': '#ffc8a2',
  '300': '#ffb784',
  '400': '#ff832b',
  '500': '#eb6200',
  '600': '#ba4e00',
  '700': '#8a3800',
  '800': '#5e2900',
  '900': '#3e1a00',
  '950': '#231000',
};

export const inclusiveRed = {
  '50': '#fff1f1',
  '100': '#ffd7d9',
  '200': '#ffc5c9',
  '300': '#ffb3b8',
  '400': '#ff8389',
  '500': '#fa4d56',
  '600': '#da1e28',
  '700': '#a2191f',
  '800': '#750e13',
  '900': '#520408',
  '950': '#2d0709',
};
export const inclusiveTeal = {
  '50': '#d9fbfb',
  '100': '#9ef0f0',
  '200': '#74e6e5',
  '300': '#3ddbd9',
  '400': '#08bdba',
  '500': '#009d9a',
  '600': '#007d79',
  '700': '#005d5d',
  '800': '#004144',
  '900': '#022b30',
  '950': '#081a1c',
};
export const inclusiveBlue = {
  '50': '#edf5ff',
  '100': '#d0e2ff',
  '200': '#bbd5ff',
  '300': '#a6c8ff',
  '400': '#78a9ff',
  '500': '#4589ff',
  '600': '#0f62fe',
  '700': '#0043ce',
  '800': '#002d9c',
  '900': '#001d6c',
  '950': '#001141',
};
export const inclusivePurple = {
  '50': '#f6f2ff',
  '100': '#e8daff',
  '200': '#decaff',
  '300': '#d4bbff',
  '400': '#be95ff',
  '500': '#a56eff',
  '600': '#8a3ffc',
  '700': '#6929c4',
  '800': '#491d8b',
  '900': '#31135e',
  '950': '#1c0f30',
};
